import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { ConfirmDialogService } from '../../service/common/dialog/confirm-dialog.service';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take } from 'rxjs/operators';
import { DienstleistungsArt } from '../../domain/model/dienstleistungsart.model';
import { DienstleistungsmoduleService } from '../../service/dienstleistungsmodule/dienstleistungsmodule.service';
import { Observable } from 'rxjs';
import { DienstleistungsModuleBeschreibung } from '../../domain/model/dienstleistungsmodulebeschreibung.model';
import { DienstleistungsModule } from '../../domain/model/dienstleistungsmodule.enum';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgForm } from '@angular/forms';
import { DienstleistungsartService } from '../../service/dienstleistungsmodule/dienstleistungsart.service';

@Component({
    selector: 'redispatch-settings-dienstleistungsarten-detail',
    templateUrl: './settings-dienstleistungsarten-detail.component.html',
    styleUrls: [
        './settings-dienstleistungsarten-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsDienstleistungsartenDetailComponent implements OnInit {
    public dienstleistungsArt: DienstleistungsArt = new DienstleistungsArt();
    public createNew: boolean = false;

    @ViewChild('dienstleistungsArtForm', { static: false }) public dienstleistungsArtForm: NgForm;

    public availableDienstleistungsmodule$: Observable<DienstleistungsModuleBeschreibung[]>;

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private dienstleistungsartService = inject(DienstleistungsartService);
    private dienstleistungsmoduleService = inject(DienstleistungsmoduleService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private confirmDialogService = inject(ConfirmDialogService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        this.availableDienstleistungsmodule$ = this.dienstleistungsmoduleService.listDienstleistungsModuleBeschreibung();

        const id = this.activatedRoute.snapshot.queryParams['dlArt'];
        this.createNew = id == null || id === '';
        if (id) {
            this.dienstleistungsartService.getDienstleistungsart(id)
                .pipe(take(1))
                .subscribe((dienstleistungsArt: DienstleistungsArt) => {
                    this.dienstleistungsArt = dienstleistungsArt;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    public containsModule(module: DienstleistungsModule): boolean {
        return this.dienstleistungsArt.dienstleistungsmodule.findIndex(value => value === module) !== -1;
    }

    public moduleChanged(event: MatCheckboxChange, module: DienstleistungsModule): void {
        if (event.checked) {
            if (this.dienstleistungsArt.dienstleistungsmodule.findIndex(value => value === module) === -1) {
                this.dienstleistungsArt.dienstleistungsmodule.push(module);
            }
        } else {
            const idx = this.dienstleistungsArt.dienstleistungsmodule.findIndex(value => value === module);
            if (idx !== -1) {
                this.dienstleistungsArt.dienstleistungsmodule.splice(idx, 1);
            }
        }
        this.dienstleistungsArtForm.form.markAsDirty();
    }

    saveDienstleistungsArt() {
        if (this.createNew) {
            this.dienstleistungsartService.createDienstleistungsart(this.dienstleistungsArt).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Die Dienstleisungsart wurde erfolgreich angelegt');
            });
        } else {
            this.dienstleistungsartService.updateDienstleistungsart(this.dienstleistungsArt).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Die Dienstleisungsart wurde erfolgreich gespeichert');
            });
        }
    }

    async deleteDienstleistungsart(dienstleistungsArt: DienstleistungsArt) {
        if (await this.confirmDialogService.confirm(
            `Möchten Sie die Dienstleisungsart "${dienstleistungsArt.title}" wirklich löschen?`,
            'Dienstleistungsart entfernen!',
            'warn',
            'Entfernen',
        )) {
            this.dienstleistungsartService.deleteDienstleistungsart(dienstleistungsArt).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Die Dienstleisungsart wurde entfernt');
            });
        }
    }
}
